import {
  makeStyles,
  createStyles,
  Theme,
  CSSProperties,
} from 'core/atoms/styles';

import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid,
} from 'templates/mdp/material-dashboard-pro-react';

export interface DashboardLayoutStyle {
  wrapper: CSSProperties;
  mainPanel: CSSProperties;
  content: CSSProperties;
  topContent: CSSProperties;
  container: CSSProperties;
  map: CSSProperties;
  mainPanelSidebarMini: CSSProperties;
  mainPanelFullWidth: CSSProperties;
  mainPanelWithPerfectScrollbar: CSSProperties;
}

export const dashboardLayoutStyle = (theme: Theme): DashboardLayoutStyle => ({
  wrapper: {
    position: 'relative',
    top: '0',
    height: '100vh',
    '&:after': {
      display: 'table',
      clear: 'both',
      content: '" "',
    },
  },
  mainPanel: {
    transitionProperty: 'top, bottom, width',
    transitionDuration: '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflow: 'auto',
    position: 'relative',
    float: 'right',
    ...transition,
    maxHeight: '100%',
    width: '100%',
    overflowScrolling: 'touch',
  },
  content: {
    // marginTop: 70,
    padding: '30px 15px',
    minHeight: 'calc(100vh - 123px)',
  },
  topContent: {
    marginTop: 0,
  },
  container: { ...containerFluid },
  map: {
    marginTop: 70,
  },
  mainPanelSidebarMini: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerMiniWidth}px)`,
    },
  },
  mainPanelFullWidth: {
    width: '100%',
  },
  mainPanelWithPerfectScrollbar: {
    overflow: 'hidden !important',
  },
});

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({ ...dashboardLayoutStyle(theme) }),
);
